// General
import React from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';

//Component
import AdminLoginForm from '../../../components/siteadmin/AdminLoginForm';

import s from './AdminLogin.css';

const AdminLogin = () => {

  return (
    <div>
      <div>
        <AdminLoginForm />
      </div>
    </div>
  );
}

AdminLogin.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(AdminLogin);